// #1029 — client-side read of the same LIVE flag score-api's demo-reseed
// handler hard-refuses on server-side (403 live_guard). This FE gate is UX
// only, never a security boundary: the backend is the actual authority and
// refuses regardless of what the client renders, so there's nothing unsafe
// about a client-visible flag here.
//
// No FE app in this repo exposed LIVE to the browser before this card — the
// only prior wiring (.github/workflows/deploy-fe-stacks.yml's `Live=` sam
// deploy param) feeds a CloudFront Function's basic-auth gate, never the
// Vite bundle. VITE_LIVE below is a new build-time env var, following the
// exact naming/reading convention every other config value in this FE
// already uses (VITE_SCORE_API_BASE_URL, VITE_COGNITO_*, ...) — wired in
// apps/scoreadmin-fe/.env (local) and .github/workflows/deploy.yml's
// build_scoreadmin_fe (deployed envs, from the `LIVE` repo/environment var).
//
// Vite inlines import.meta.env.* at BUILD time, so it can't be flipped at
// runtime — including inside a single Cypress run, which builds once then
// serves that one bundle to every spec. To let Cypress assert the "hidden
// when LIVE=true" AC without a second build pipeline, isLive() also honors a
// window-level test override, but ONLY when window.Cypress is set — Cypress
// itself stamps that onto the page it drives, so a real visitor can never
// trigger this branch.
export function isLive() {
  if (typeof window !== "undefined" && window.Cypress && window.__CYPRESS_LIVE_OVERRIDE__ != null) {
    return window.__CYPRESS_LIVE_OVERRIDE__ === true;
  }
  return import.meta.env.VITE_LIVE === "true";
}
